import { gql } from 'apollo-angular'

import {
  EDITORIAL_BOARD,
  MAGAZINE_BASIC_FIELDS,
  MAGAZINE_DETAIL_FIELDS,
} from '../../fragments/magazine.fragments'
import { SEO_META_FIELDS } from '../../fragments/seo.fragment'

export class MagazineOptions {
  fetchEditions?: boolean
}

export const GET_MAGAZINE_BY_ID = gql`
  ${MAGAZINE_BASIC_FIELDS}
  ${MAGAZINE_DETAIL_FIELDS}
  ${EDITORIAL_BOARD}
  query getMagazineById($id: Int!, $fetchEditions: Boolean = false) {
    Magazine(id: $id, select: true) {
      ...MagazineBasicFields
      ...MagazineDetailFields
      ...EditorialBoard
      user_access
      ${SEO_META_FIELDS}
      editions @include(if: $fetchEditions) {
        docs {
          id
          title
          slug
          edition_version
          year
        }
      }
    }
  }
`
